import {
    useGetGroupMembersLazyQuery as _useGetGroupMembersLazyQuery,
    useGetUserAndGroupListLazyQuery as _useGetUserAndGroupListLazyQuery,
    useGetUserAndGroupListQuery as _useGetUserAndGroupsListQuery,
    useGetUserDetailsByIdLazyQuery as _useGetUserDetailsByIdLazyQuery,
    useGetUserGroupsListQuery as _useGetUserGroupsListQuery,
    useGetUsersListQuery as _useGetUsersListQuery,
} from '../generated/graphql-types';

export const useGetUsersListQuery = (
    pattern?: string,
    skipIds?: Array<string>,
) => {
    const { data, error, loading } = _useGetUsersListQuery({
        variables: {
            pattern,
            skipIds,
        },
    });

    return {
        error,
        loading,
        data: data?.getUsersList,
    };
};

export const useGetUserGroupListQuery = (
    pattern?: string,
    skipIds?: Array<string>,
) => {
    const { data, error, loading } = _useGetUserGroupsListQuery({
        variables: {
            pattern,
            skipIds,
        },
    });

    return {
        error,
        loading,
        data: data?.getUserGroupsList,
    };
};

export const useGetUserAndGroupListQuery = (
    pattern?: string,
    skipIds?: Array<string>,
) => {
    const { data, error, loading, refetch } = _useGetUserAndGroupsListQuery({
        variables: {
            pattern,
            skipIds,
        },
    });

    return {
        error,
        loading,
        data,
        refetch,
    };
};

export const useGetUserAndGroupListLazyQuery = () => {
    const [
        getUserGroupsList,
        { data, loading, error },
    ] = _useGetUserAndGroupListLazyQuery();

    return {
        getUserGroupsList,
        data,
        loading,
        error,
    };
};

export const useGetGroupMembersLazyQuery = () => {
    const [
        getGroupMembers,
        { loading, data, error },
    ] = _useGetGroupMembersLazyQuery();

    return {
        getGroupMembers,
        error,
        loading,
        data: data?.getGroupMembers,
    };
};

export const useGetUserDetailsByIdLazyQuery = (
    ids: string[],
    orgOverride?: string,
) => {
    const [
        getUserById,
        { data, error, loading },
    ] = _useGetUserDetailsByIdLazyQuery({
        variables: {
            ids,
            orgOverride,
        },
    });

    return {
        error,
        loading,
        data,
        getUserById,
    };
};
